// extracted by mini-css-extract-plugin
export default {"stats":"Stats_stats__y7rPh","gameOver":"Stats_gameOver__1-HJM"};